import _ from 'lodash'

class UnpaidBalanceModalCtrl {
    /** @ngInject */
    constructor($window, $timeout, $q, Contract, ContactTelephone, ErrorCatcher) {
        this.$window = $window
        this.$timeout = $timeout
        this.$q = $q
        this.Contract = Contract
        this.ContactTelephone = ContactTelephone
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.error = null
        this.isRegularizing = false
    }

    regularize() {
        this.isRegularizing = true
        this.Contract.regularize({ id: this.resolve.unpaidContract.id }).$promise.then((result) => {
            this.$window.location = result.redirectUrl
        }).catch((error) => {
            this.isRegularizing = false
            this.ErrorCatcher.catchError(error)
            this.error = error
        })
    }

    toAbsolute(amount) {
        return Math.abs(_.toNumber(amount))
    }
}

export default {
    template: require('./unpaidBalanceModal.jade')(),
    controller: UnpaidBalanceModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/navbar/modal/unpaidBalanceModal.js